import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { DefaultDateFormat } from "../../../helper/fixcode";

export default function ReportAssetDispatchComponent() {
  const [assetDispatchList, setAssetDispatchList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Dispatch`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetDispatchList(0);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetDispatchList = async (assetDispatchId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetDispatchList(
        assetDispatchId
      );
      setAssetDispatchList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetDispatchList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="assetRequestNo"
                    caption="Asset Request No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="assetMovementNo"
                    caption="Asset Movement No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="assetDispatchNo"
                    caption="Asset Dispatch No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="dispatchDate"
                    caption="Dispatch Date"
                    allowFiltering={false}
                    allowSearch={true}
                    dataType="date"
                    format="dd-MMM-yyyy"
                  />
                  <Column
                    dataField="assetName"
                    caption="Asset Name"
                    allowFiltering={false}
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.assetName || ""} ${data?.assetNo || ""}`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.assetName ?? ""}</span>
                          {data?.data?.assetNo && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.assetNo ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="categoryName"
                    caption="Category"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.categoryName || ""} ${
                        data?.subCategoryName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.categoryName ?? ""}</span>
                          {data?.data?.subCategoryName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.subCategoryName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromProjectName"
                    caption="Project"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromProjectName || ""} ${
                        data?.toProjectName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromProjectName ?? ""}</span>
                          {data?.data?.toProjectName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toProjectName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromLocation"
                    caption="Transfer From/To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromLocation || ""} ${
                        data?.toLocation || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromLocation ?? ""}</span>
                          {data?.data?.toLocation && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toLocation ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromUserFullName"
                    caption="From"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromUserFullName || ""} ${
                        data?.fromDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromUserFullName ?? ""}</span>
                          {data?.data?.fromDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.fromDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="toUserFullName"
                    caption="To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.toUserFullName || ""} ${
                        data?.toDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.toUserFullName ?? ""}</span>
                          {data?.data?.toDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="transferType"
                    caption="Dispatch Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="jobStartDate"
                    caption="Job Start Date"
                    allowFiltering={false}
                    allowSearch={true}
                    dataType="datetime"
                    format={DefaultDateFormat.GridDateTime24Format}
                  />
                  <Column
                    dataField="jobEndDate"
                    caption="Job End Date"
                    allowFiltering={false}
                    allowSearch={true}
                    dataType="datetime"
                    format={DefaultDateFormat.GridDateTime24Format}
                  />
                  <Column
                    dataField="assetDispatchStatus"
                    caption="Status"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="updatedDate"
                    caption="Updated By"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.updatedDate || ""} ${
                        data?.updatedByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.updatedDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.updatedDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.updatedDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.updatedByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetDispatchList(0);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset Dispatch Report" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
